import {Action, createAction, props} from '@ngrx/store';

export const undo = createAction(
  '[App] Undo',
  props<{action: Action}>()
);
